import {getJson} from '@/util/ajaxUtils';

export function autoAuth(data) {
    return getJson('/open/clientapps/wxautoauth-from-wx', {params: data});
}

export function wxAuth(data) {
    return getJson('/open/clientapps/wxauth-from-wx', {params: data});
}
